import React from 'react';

export default function RichTextBranch(props) {
	const { children, component, data, renderStyles: { document, h1, h2, h3, h4, h5, h6, p, a, ul, li, ol, liText, hr }, element } = props;

	const renderElement = (children) => {
		switch (element) {
			case 'h1':
				return <h1 style={h1}>{children}</h1>
			case 'h2':
				return <h2 style={h2}>{children}</h2>
			case 'h3':
				return <h3 style={h3}>{children}</h3>
			case 'h4':
				return <h4 style={h4}>{children}</h4>
			case 'h5':
				return <h5 style={h5}>{children}</h5>
			case 'h6':
				return <h6 style={h6}>{children}</h6>
			case 'none':
				return <React.Fragment>{children}</React.Fragment>
			case 'p':
			default:
				return <p style={p}>{children}</p>
		}
	}

	if (props.parentNodeType === 'list-item' && component !== 'hyperlink') {
		return <span style={liText}>{ children }</span>
	}

	switch(component) {
		case 'asset-hyperlink':
			return <a target={"_blank"} href={data.target.file.url} style={a} download>{ children }</a>
		case 'document':
			return <span style={document}>{ children }</span>;
		case 'heading-1':
			return <h1 style={h1}>{ children }</h1>;
		case 'heading-2':
			return <h2 style={h2}>{ children }</h2>;
		case 'heading-3':
			return <h3 style={h3}>{ children }</h3>;
		case 'heading-4':
			return <h4 style={h4}>{ children }</h4>;
		case 'heading-5':
			return <h5 style={h5}>{ children }</h5>;
		case 'heading-6':
			return <h6 style={h6}>{ children }</h6>;
		case 'paragraph':
			return renderElement(children);
		case 'hyperlink':
			return <a target={"_blank"} href={data.uri} style={a}>{ children }</a>;
		case 'unordered-list':
			return <ul style={ul}>{ children }</ul>
		case 'ordered-list':
			return <ol style={ol}>{ children }</ol>
		case 'list-item':
			return <li style={li}>{ children }</li>
		case 'hr':
			return <hr style={hr} />
		default:
			// TODO - Add error handling / logging if we are trying to render an unknown contentful branch (p, h1, ul, li, etc.)
			return children;
	}
}
